import { Auth0Provider } from '@auth0/auth0-react';

// Note: required attributes to be decorated on auth vendor provider componnet for basic auth flow for both loginWithRedirect, ID token and AT:
    // domain, clientId, authorzationParams={redirect_uri, scope (for if want IDT), audience (for if want AT)}
// Note: optional / additional attributes that can be decorated on auth vendor provider component to add additional functionality / control:
    // onRedirectCallback, cacheLocation, etc. */}

// Note: default token cacheLocation="memory"; 
    // therefore, default cache location checked during silent token try in cache in auth vendors provider component re-run and getAccessTokenSilently is to check browser local page memory for cached tokens

const AuthProvider = ({ children }) => {
    // DEBUGGING LOGS: to confirm varaibles correctly moved migrating over to prod auth tenant and integrating purchased domain
    // console.log("[AUTH0 ENV] domain:", process.env.REACT_APP_PUBLIC_AUTH0_DOMAIN);
    // console.log("[AUTH0 ENV] clientId:", process.env.REACT_APP_PUBLIC_AUTH0_CLIENT_ID);
    // console.log("[AUTH0 ENV] audience:", process.env.REACT_APP_PUBLIC_AUTH0_AUDIENCE);
    
    return(
        <Auth0Provider
        domain={process.env.REACT_APP_PUBLIC_AUTH0_DOMAIN}              // TO UPDATE: ONCE WE BUY CUSTOM DOMAIN FOR FRONT END SIMPLE HTTP WEB SERVER ADDRESS
        clientId={process.env.REACT_APP_PUBLIC_AUTH0_CLIENT_ID}
        authorizationParams={{
            redirect_uri: window.location.origin + "/#/authguard/dashboards/public-comparables",
            scope: "openid profile",
            audience: process.env.REACT_APP_PUBLIC_AUTH0_AUDIENCE       // TO UPDATE: once we go to Auth0 Dashboard → Applications → APIs → Create API so we dont inherit the default backend scope from the pre-made Auth0 Management API
        }}
        >
            {children}
        </Auth0Provider>
    )
}

export default AuthProvider